import Headroom from "headroom.js";

// select your header or whatever element you wish
const header = document.querySelector("#js-header");

const headroom  = new Headroom(header, {
	"offset": 100,
	"tolerance": 5
});
headroom.init();